import React, { useState, useEffect } from "react";
import {getDataWithClassforInstructor} from "../../../lib/classdetailview"
import StudentGridBox from "./studentgridbox";
import {  useParams, Link } from 'react-router-dom';
import {useAuth} from "../../../usercontext";

export default function InstructorStudentGrid() {
  const [profiles, setProfiles] = useState([]);
  const { profile, setProfile } = useAuth();
  let { slug } = useParams();
  const instructorId = profile.id;

  async function GetData() {

    const classd = await getDataWithClassforInstructor(slug,instructorId);
    //console.log("classd",classd);
    setProfiles(classd);
  }

  useEffect(() => {
    GetData();
  }, [])

  return (
    <>
      <div className="tak-instruct-group">
        <div className="row">
          <div className="col-md-12">
            <div className="settings-widget">
              <div className="settings-inner-blk p-0">
                <div className="sell-course-head student-meet-head comman-space border-0">
                  <div className="tak-head d-flex align-items-center justify-content-between">
                    <div>
                      <h3>ClassName - Students</h3>
                    </div>
                    <div className="ticket-btn-grp">
                      <Link to={`/instructor/instructor-taskmanage-edit/Class/${slug}`}>Add Task to Class</Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {profiles.length > 0 ? profiles.map(function (data) {
            /* <StudentGridBox  data={data} />*/
            return (
              <StudentGridBox data={data} key={data.id} />
              /*
          <div className="col-xl-4 col-lg-6 col-md-6 d-flex" key={data.id}>
            <div className="student-box flex-fill bg-white">
              <div className="student-box-blks">
                <div className="student-img">
                  <Link to={`/instructor/instructor-studentdetail/${data.id}`}>
                    <img
                      className="img-fluid rounded-circle"
                      alt="Students Info"
                      src={emptyAvatar}
                    />
                  </Link>
                </div>
                <div className="student-content pb-0">
                  <h5>
                    <Link to={`/instructor/instructor-studentdetail/${data.id}`}>{data.name +" " +  data.surname}</Link>
                  </h5>
                  <div className="loc-blk d-flex align-items-center justify-content-center">
                    <i className="feather-map-pin me-2"></i>
                    <p>{data.schoolname}</p>
                  </div>
                </div>
              </div>
              <div className="enrol-student-foot">
                <ul>
                  <li>
                    Class : <h6> {data.class} </h6>
                  </li>
                  <li>
                    Progress
                    <div className="instruct-stip d-flex align-items-center">
                      {
                        data.isActive ?  <i className="fas fa-circle-check green h3"></i> : 
                        <i className="fas fa-minus-circle red h3"></i> 
                      }

                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          */
            )
          }) : ""}


        </div>
      </div>
    </>
  );
}
